import React from 'react'
import PropTypes from 'prop-types'

import strings from 'utils/strings'

import { Table } from 'components/patterns'

const columns = [
  {
    key: 'refNo',
    title: strings.refNo,
    dataIndex: 'refNo',
    width: 1,
  },
  {
    key: 'description',
    title: strings.description,
    dataIndex: 'description',
    render: (text, { configuration: { value } }) => {
      return `${text} = ${value}`
    },
  },
]

const BoundariesTable = ({ dataSource, title, className }) => {
  return (
    <Table
      className={className}
      title={title}
      size="small"
      dataSource={dataSource}
      columns={columns}
      rowKey="refNo"
    />
  )
}

BoundariesTable.propTypes = {
  title: PropTypes.string,
  dataSource: PropTypes.array,
  className: PropTypes.string,
}

export default BoundariesTable
